// WEARYANI BY SKALE, version Shopify : le menu, les tiroirs, le sac et la fiche produit (le hanout).
(() => {
	const R = window.YANI || {};
	const $ = (s, el = document) => el.querySelector(s);
	const $$ = (s, el = document) => [...el.querySelectorAll(s)];

	// Les prix au format de la boutique (« {{amount_with_comma_separator}} € », etc.).
	const prix = (centimes) => {
		const n = Math.round(centimes) / 100;
		const sep = (v, mille, dec, decimales = 2) => {
			const [ent, fr] = v.toFixed(decimales).split(".");
			return ent.replace(/\B(?=(\d{3})+(?!\d))/g, mille) + (fr ? dec + fr : "");
		};
		const f = R.formatPrix || "{{amount_with_comma_separator}} €";
		return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => ({
			amount: sep(n, ",", "."),
			amount_no_decimals: sep(n, ",", ".", 0),
			amount_with_comma_separator: sep(n, ".", ","),
			amount_no_decimals_with_comma_separator: sep(n, ".", ",", 0),
			amount_with_space_separator: sep(n, " ", ","),
			amount_with_apostrophe_separator: sep(n, "'", "."),
		})[k] || sep(n, ".", ",")).replace(/<[^>]+>/g, "");
	};
	const prixClub = (c) => Math.round((c * (100 - (R.remiseClub || 0))) / 1000) * 10;

	/* ---------- Menu ---------- */
	const burger = $(".burger");
	if (burger) {
		const basculer = (ouvert) => {
			burger.setAttribute("aria-expanded", String(ouvert));
			burger.textContent = ouvert ? "Fermer" : "Menu";
			document.body.classList.toggle("menu-ouvert", ouvert);
		};
		burger.addEventListener("click", () => basculer(burger.getAttribute("aria-expanded") !== "true"));
		document.addEventListener("keydown", (e) => {
			if (e.key === "Escape" && document.body.classList.contains("menu-ouvert")) { basculer(false); burger.focus(); }
		});
	}

	/* ---------- Tiroirs ---------- */
	const voile = $("[data-voile]");
	let retourFocus = null;
	const ouvrir = (id) => {
		const t = document.getElementById(id);
		if (!t) return;
		$$(".tiroir.voir").forEach((x) => x.classList.remove("voir"));
		retourFocus = document.activeElement;
		t.classList.add("voir");
		voile?.classList.add("voir");
		setTimeout(() => $(".fermer", t)?.focus(), 50);
	};
	const fermer = () => {
		$$(".tiroir.voir").forEach((x) => x.classList.remove("voir"));
		voile?.classList.remove("voir");
		retourFocus?.focus?.();
	};
	document.addEventListener("click", (e) => {
		const o = e.target.closest("[data-ouvrir]");
		if (o) { e.preventDefault(); ouvrir(o.dataset.ouvrir); }
		if (e.target.closest("[data-fermer]") || e.target === voile) fermer();
	});
	document.addEventListener("keydown", (e) => e.key === "Escape" && fermer());

	/* ---------- Le sac ---------- */
	const compteur = (n) => $$("[data-compte-sac]").forEach((c) => {
		c.textContent = n;
		c.dataset.n = n;
		c.classList.remove("saute"); void c.offsetWidth; c.classList.add("saute");
	});

	// La ligne du bas : ce qu'il manque pour la livraison offerte (seuil réglé en devise de la boutique).
	const lignePort = $("[data-ligne-port]");
	const seuilPort = R.livraisonOfferte ? Math.round(R.livraisonOfferte * +(window.Shopify?.currency?.rate || 1)) : 0;
	let totalSac = 0;
	const majPort = (total) => {
		totalSac = total;
		document.dispatchEvent(new CustomEvent("yani:sac"));
		if (!lignePort || !seuilPort) return;
		const seuil = seuilPort;
		const reste = seuil - total;
		const texte = $("[data-ligne-port-texte]", lignePort);
		if (total <= 0) texte.innerHTML = `Livraison offerte dès <b>${prix(seuil)}</b>.`;
		else if (reste > 0) texte.innerHTML = `Zid <b>${prix(reste)}</b> et la livraison est pour nous.`;
		else texte.innerHTML = `Mabrouk, <b>la livraison est pour nous.</b>`;
		lignePort.classList.toggle("offerte", total > 0 && reste <= 0);
		if (total > 0 && reste <= 0) $$("[data-sac-port]").forEach((e) => (e.textContent = "Offerte"));
		$("[data-ligne-port-jauge]", lignePort).style.width = Math.min(100, (total / seuil) * 100) + "%";
		lignePort.hidden = false;
	};
	majPort(+($("[data-sac-contenu]")?.dataset.total || 0));

	const remplacerSac = (html) => {
		if (!html) return;
		const neuf = new DOMParser().parseFromString(html, "text/html").querySelector("[data-sac-contenu]");
		const ancien = $("[data-sac-contenu]");
		if (neuf && ancien) { ancien.replaceWith(neuf); compteur(neuf.dataset.compte); majPort(+neuf.dataset.total); }
	};
	const titreSac = (t) => { const h = $("[data-sac-titre]"); if (h) h.textContent = t; };
	document.addEventListener("click", (e) => {
		if (!e.target.closest("[data-ouvrir-sac]") || !$("#tiroir-sac")) return;
		e.preventDefault();
		titreSac("Ton sac");
		ouvrir("tiroir-sac");
	});

	// Le bonbon de la monnaie : il tombe du bouton dans le sac, puis un petit mot.
	const BONBON = '<svg viewBox="0 0 48 48" aria-hidden="true"><path d="M10 24 2 16v16z" fill="#00843D" stroke="#000" stroke-width="2" stroke-linejoin="round"/><path d="M38 24l8-8v16z" fill="#00843D" stroke="#000" stroke-width="2" stroke-linejoin="round"/><circle cx="24" cy="24" r="13" fill="#FFD400" stroke="#000" stroke-width="2.5"/><path d="M15 20c4 3 14 3 18 0M15 28c4 3 14 3 18 0" stroke="#00843D" stroke-width="2.5" fill="none" stroke-linecap="round"/></svg>';
	const visible = (el) => el && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== "hidden";
	const bonbon = (depuis) => {
		const mot = $("[data-bonbon-mot]");
		if (mot) {
			mot.innerHTML = `${BONBON}<span><b>Bsahtek ! C'est dans le sac.</b> Et le bonbon de la monnaie, c'est cadeau.</span>`;
			mot.hidden = false;
			mot.classList.remove("voir"); void mot.offsetWidth; mot.classList.add("voir");
			clearTimeout(bonbon.t);
			bonbon.t = setTimeout(() => { mot.classList.remove("voir"); mot.hidden = true; }, 2600);
		}
		if (matchMedia("(prefers-reduced-motion: reduce)").matches || !depuis?.animate) return;
		const cible = $$("[data-cible-bonbon], .panier-lien").find(visible) || $("[data-bas]");
		if (!visible(cible)) return;
		const a = depuis.getBoundingClientRect(), b = cible.getBoundingClientRect();
		const el = document.createElement("span");
		el.className = "bonbon-vol";
		el.innerHTML = BONBON;
		el.style.left = a.left + a.width / 2 - 17 + "px";
		el.style.top = a.top - 17 + "px";
		document.body.append(el);
		const dx = b.left + b.width / 2 - (a.left + a.width / 2), dy = b.top + 6 - a.top;
		el.animate([
			{ transform: "translate(0, 0) rotate(0) scale(1)" },
			{ transform: `translate(${dx * .5}px, ${Math.min(dy, 0) - 60}px) rotate(200deg) scale(1.15)`, offset: .45 },
			{ transform: `translate(${dx}px, ${dy}px) rotate(400deg) scale(.5)` },
		], { duration: 700, easing: "cubic-bezier(.3,.6,.4,1)" }).onfinish = () => el.remove();
	};
	document.addEventListener("click", async (e) => {
		const b = e.target.closest("[data-changer]");
		if (!b) return;
		b.disabled = true;
		try {
			const r = await fetch(R.majPanier + ".js", {
				method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
				body: JSON.stringify({ id: b.dataset.changer, quantity: +b.dataset.qteCible, sections: "sac" }),
			});
			const d = await r.json();
			remplacerSac(d.sections?.sac);
		} catch { location.href = R.panier; }
	});

	/* ---------- La fiche : le hanout ---------- */
	const fiche = $("[data-fiche]");
	if (!fiche) return;
	const produit = JSON.parse($("[data-produit]", fiche).textContent);
	const form = $("[data-form-ajout]", fiche) || $("form[action*='/cart/add']", fiche);
	const champId = $("[data-id-variante]", fiche);
	const champQ = $("[data-qte-champ]", fiche);
	const ticket = $("[data-ticket]", fiche);
	const noms = produit.options.map((o) => (typeof o === "string" ? o : o.name).toLowerCase());
	const iCouleur = noms.findIndex((n) => ["couleur", "color", "colour"].includes(n));
	const iTaille = noms.findIndex((n) => ["taille", "size"].includes(n));

	// L'état : une valeur par option (null = pas encore choisie), et la quantité.
	const depart = produit.variants.find((v) => v.id === +champId.value) || produit.variants.find((v) => v.available) || produit.variants[0];
	const choix = depart.options.slice();
	if (!champId.value && iTaille >= 0) choix[iTaille] = null;
	let q = 1;

	const variante = () => (choix.includes(null) ? null : produit.variants.find((v) => v.options.every((o, i) => o === choix[i])) || null);
	const imprimer = (el) => { if (!el) return; el.classList.remove("imprime"); void el.offsetWidth; el.classList.add("imprime"); };

	// Les vues de l'étagère : on ne montre que les photos de la couleur choisie.
	const vues = $("[data-vues]", fiche);
	const boutonsVues = $("[data-boutons-vues]", fiche);
	const majVues = () => {
		const c = iCouleur >= 0 ? choix[iCouleur] : "";
		const visibles = [];
		$$(".etagere__vue", vues).forEach((f) => {
			const ok = !f.dataset.couleur || f.dataset.couleur === c;
			f.hidden = !ok;
			if (ok) visibles.push(f);
		});
		boutonsVues.innerHTML = "";
		if (visibles.length > 1) visibles.forEach((f, i) => {
			const b = document.createElement("button");
			b.type = "button";
			b.textContent = f.dataset.libelle;
			b.setAttribute("aria-pressed", String(i === 0));
			b.addEventListener("click", () => vues.scrollTo({ left: vues.clientWidth * i, behavior: "smooth" }));
			boutonsVues.append(b);
		});
		vues.scrollTo({ left: 0 });
	};
	vues?.addEventListener("scroll", () => requestAnimationFrame(() => {
		const i = Math.round(vues.scrollLeft / vues.clientWidth);
		$$("button", boutonsVues).forEach((b, k) => b.setAttribute("aria-pressed", String(k === i)));
	}), { passive: true });

	const disponible = (i, valeur) => produit.variants.some((v) => v.available && v.options[i] === valeur && v.options.every((o, k) => k === i || choix[k] === null || k === iTaille || o === choix[k]));

	const maj = ({ imprimerOption = null } = {}) => {
		const v = variante();
		const base = v || produit.variants.find((x) => choix.every((c, i) => c === null || x.options[i] === c)) || depart;
		champId.value = v ? v.id : "";
		champQ.value = q;

		// Les boutons d'options
		$$("[data-option]", fiche).forEach((fs) => {
			const i = +fs.dataset.option;
			$$("[data-valeur]", fs).forEach((b) => {
				b.setAttribute("aria-pressed", String(b.dataset.valeur === choix[i]));
				b.dataset.indispo = String(!disponible(i, b.dataset.valeur));
			});
			const val = $("[data-val-option]", fs);
			if (val) val.textContent = choix[i] ?? "à choisir";
		});
		$$("[data-tailles-guide] [data-valeur]").forEach((b) => b.setAttribute("aria-pressed", String(iTaille >= 0 && b.dataset.valeur === choix[iTaille])));
		$$("#tiroir-guide tr[data-taille]").forEach((tr) => tr.classList.toggle("choisie", iTaille >= 0 && tr.dataset.taille === choix[iTaille]));

		// L'étiquette et le ticket
		const p = base.price;
		$$("[data-prix]", fiche).forEach((e) => (e.textContent = prix(p)));
		$$("[data-prix-club]", fiche).forEach((e) => (e.textContent = prix(prixClub(p))));
		$("[data-t-q]", fiche).textContent = q;
		$("[data-t-st]", fiche).textContent = prix(p * q);
		// Le port tombe si le sac, avec ce t-shirt, atteint le seuil de la livraison offerte.
		const port = seuilPort && totalSac + p * q >= seuilPort ? 0 : (R.port || 0);
		const tp = $("[data-t-port]", fiche);
		if (tp) tp.textContent = port ? prix(port) : "Offerte";
		const total = prix(p * q + port);
		$("[data-t-total]", fiche).textContent = total;
		const club = $("[data-t-club]", fiche);
		if (club) club.textContent = prix(prixClub(p) * q);
		$$("[data-t-option]", fiche).forEach((l) => {
			const i = +l.dataset.tOption;
			$("[data-t-val]", l).innerHTML = choix[i] ? choix[i].replace(/</g, "&lt;") : '<span class="curseur">&nbsp;</span>';
			if (imprimerOption === i) imprimer(l);
		});

		// Les boutons d'achat
		const libelle = (b) => $("[data-libelle]", b);
		const epuise = v && !v.available;
		$$("[data-ajout], [data-ajout-barre]").forEach((b) => {
			b.dataset.vide = String(!v);
			b.disabled = !!epuise;
			const l = libelle(b);
			if (l) l.textContent = epuise ? "Épuisé, repasse plus tard" : v ? l.dataset.libelle : (iTaille >= 0 && choix[iTaille] === null ? "Choisis ta taille" : "Choisis une option");
		});
		$("[data-t-bouton]", fiche).textContent = total;
		const tb = $("[data-t-bouton-barre]");
		if (tb) tb.textContent = total;
		const resume = $("[data-resume-choix]");
		if (resume) resume.textContent = choix.map((c) => c ?? "taille ?").join(" · ");
		if (v) $$("[data-alerte-taille]").forEach((a) => (a.hidden = true));

		// L'URL suit la variante, pour pouvoir partager le bon t-shirt.
		if (v) history.replaceState(null, "", `${location.pathname}?variant=${v.id}`);
	};

	document.addEventListener("click", (e) => {
		const b = e.target.closest("[data-valeur]");
		if (!b) return;
		const fs = b.closest("[data-option]");
		const i = fs ? +fs.dataset.option : b.closest("[data-tailles-guide]") ? iTaille : -1;
		if (i < 0) return;
		const avant = choix[i];
		choix[i] = b.dataset.valeur;
		if (i === iCouleur && avant !== choix[i]) majVues();
		maj({ imprimerOption: avant !== choix[i] ? i : null });
	});
	$$("[data-qte]", fiche).forEach((b) => b.addEventListener("click", () => {
		q = Math.min(99, Math.max(1, q + +b.dataset.qte));
		$("[data-qte-val]", fiche).textContent = q;
		imprimer($("[data-t-st]", fiche).parentElement);
		maj();
	}));

	// La barre d'achat prend la place des onglets du bas quand le vrai bouton sort de l'écran.
	const barre = $("[data-barre]");
	const bas = $("[data-bas]");
	const principal = $("[data-principal]", fiche);
	if (barre && bas) bas.append(barre);
	if (barre && principal && "IntersectionObserver" in window) {
		new IntersectionObserver(([e]) => {
			const voir = !e.isIntersecting && e.boundingClientRect.top < 0;
			barre.classList.toggle("voir", voir);
			bas?.classList.toggle("bas--achat", voir);
			barre.setAttribute("aria-hidden", String(!voir));
		}).observe(principal);
	}
	$("[data-ajout-barre]")?.addEventListener("click", () => form.requestSubmit ? form.requestSubmit() : form.submit());

	// « Yalla, j'encaisse »
	const erreur = $("[data-erreur]", fiche);
	form.addEventListener("submit", async (e) => {
		e.preventDefault();
		const v = variante();
		if (!v) {
			const t = $("[data-tailles]", fiche);
			if (t) { t.classList.remove("secoue"); void t.offsetWidth; t.classList.add("secoue"); t.scrollIntoView({ behavior: "smooth", block: "center" }); }
			$$("[data-alerte-taille]").forEach((a) => (a.hidden = false));
			return;
		}
		const bouton = $("[data-ajout]", fiche);
		bouton.setAttribute("aria-busy", "true");
		erreur.hidden = true;
		try {
			const r = await fetch(R.ajout + ".js", {
				method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" },
				body: JSON.stringify({ items: [{ id: v.id, quantity: q }], sections: "sac" }),
			});
			const d = await r.json();
			if (!r.ok) throw new Error(d.description || d.message || "Ça n'a pas marché.");
			remplacerSac(d.sections?.sac);
			bonbon(bas?.classList.contains("bas--achat") ? $("[data-ajout-barre]") : bouton);
			titreSac("Mabrouk, c'est dans le sac");
			ticket.classList.add("detache");
			setTimeout(() => {
				ticket.style.transition = "none"; ticket.classList.remove("detache"); void ticket.offsetWidth; ticket.style.transition = "";
				ouvrir("tiroir-sac");
			}, 900);
		} catch (err) {
			erreur.textContent = err.message;
			erreur.hidden = false;
		} finally {
			bouton.removeAttribute("aria-busy");
		}
	});

	document.addEventListener("yani:sac", () => maj());
	majVues();
	maj();
})();
